export default __webpack_public_path__ + "static/media/lemon_ice_tea_thumbnail.527b9073.JPG";